export interface DurationFilterOptions {
  // when true, the stored/serialized value is in SECONDS; the UI works in minutes
  inSeconds?: boolean;
}

export interface DurationConverters {
  minutesToValue: (value: number | undefined) => number | undefined; // UI -> stored
  valueToMinutes: (value: number | undefined) => number | undefined; // stored -> UI
}

export const getDurationConverters = (inSeconds: boolean): DurationConverters => {
  const factor = inSeconds ? 60 : 1;
  return {
    minutesToValue: (value) => (value == null ? value : value * factor),
    valueToMinutes: (value) => (value == null ? value : value / factor),
  };
};
